var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"gl-font-bold",class:_vm.colorClass,attrs:{"data-testid":"component-label-name"}},[_vm._v(_vm._s(_vm.capitalizedName))]),_vm._v(" "),_c('span',{staticClass:"gl-mx-1",attrs:{"data-testid":"component-label-separator"}},[_vm._v("·")])])
}
var staticRenderFns = []

export { render, staticRenderFns }